export default `{
  profiles {
    id
    givenName
    familyName
  }
}`;